<template>
  <div class="grid grid-flow-row gap-4">
    <div class="flex justify-center min-height-auto">
      <h1
        class="text-3xl text-center font-bold leading-none tracking-tight text-gray-900 md:text-3xl lg:text-3xl"
      >
        Genera tu presupuesto
      </h1>
    </div>

    <form @submit.prevent="submitForm">
      <div
        class="lg:w-[980px] md:w-[980px] px-4 sm:px-6 lg:px-8 mx-auto my-4 sm:my-10"
      >
        <div class="grid md:grid-cols-3 lg:grid-cols-3 gap-8 mb-5">
          <div class="lg:flex md:flex items-center justify-between">
            <label
              for="fecha"
              class="block mr-1 text-sm font-medium text-gray-900"
              >Fecha:</label
            >
            <input
              type="text"
              v-model="formData.fecha"
              id="fecha"
              class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
            />
          </div>

          <div class="lg:flex md:flex items-center justify-between">
            <label
              for="codigo"
              class="block mr-1 text-sm font-medium text-gray-900"
              >Codigo:</label
            >
            <input
              type="text"
              v-model="formData.codigo"
              id="codigo"
              class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
            />
          </div>

          <div class="lg:flex md:flex items-center justify-between">
            <label
              for="nombre"
              class="block mr-1 text-sm font-medium text-gray-900"
              >Nombre:</label
            >
            <input
              type="text"
              v-model="formData.nombre"
              id="nombre"
              class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
            />
          </div>

          <div class="lg:flex md:flex items-center justify-between">
            <label
              for="email"
              class="block mr-1 text-sm font-medium text-gray-900"
              >Email:</label
            >
            <input
              type="text"
              v-model="formData.email"
              id="email"
              class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
            />
          </div>

          <div class="lg:flex md:flex items-center justify-between">
            <label
              for="telefono"
              class="block mr-1 text-sm font-medium text-gray-900"
              >Telefono:</label
            >
            <input
              type="text"
              v-model="formData.telefono"
              id="telefono"
              class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
            />
          </div>

        </div>

        <div class="mb-6 p-4 border border-gray-200 rounded-lg">
          <h3 class="text-lg font-semibold mb-4">Agregar Servicio</h3>

          <div class="grid md:grid-cols-3 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Tipo de Servicio
              </label>
              <select
                v-model="nuevoServicio.tipoId"
                class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
                @change="filtrarServiciosPorTipo"
              >
                <option disabled :value="null">Seleccione un tipo</option>
                <option
                  v-for="tipo in tiposServicioUnicos"
                  :key="tipo.id"
                  :value="tipo.id"
                >
                  {{ tipo.nombre }}
                </option>
              </select>
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Servicio
              </label>
              <select
                v-model="nuevoServicio.id"
                class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
                :disabled="!nuevoServicio.tipoId"
              >
                <option disabled :value="null">Seleccione un servicio</option>
                <option
                  v-for="servicio in serviciosFiltrados"
                  :key="servicio.id"
                  :value="servicio.id"
                >
                  {{ servicio.nombre }} (${{ formatMoney(servicio.precio) }})
                </option>
              </select>
            </div>

            <div class="flex items-end">
              <button
                type="button"
                @click="agregarServicio"
                class="px-4 py-2 bg-green-400 text-white rounded-lg hover:bg-green-600 disabled:opacity-50"
                :disabled="!nuevoServicio.id"
              >
                Agregar
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="serviciosSeleccionados.length > 0"
          class="mb-6 border border-gray-200 p-4 rounded-lg space-y-4"
        >
          <h3 class="text-lg font-semibold">Servicios Seleccionados</h3>

          <div class="hidden sm:grid sm:grid-cols-6">
            <div class="text-xs font-medium text-gray-500 uppercase">
              Servicio
            </div>
            <div class="text-start text-xs font-medium text-gray-500 uppercase">
              Tipo
            </div>
            <div
              class="col-span-2 text-start text-xs font-medium text-gray-500 uppercase"
            >
              Descripción
            </div>
            <div class="text-start text-xs font-medium text-gray-500 uppercase">
              Precio
            </div>
            <div class="text-end text-xs font-medium text-gray-500 uppercase">
              Acción
            </div>
          </div>

          <div class="hidden sm:block border-b border-gray-200"></div>

          <div
            v-for="(servicio, index) in serviciosSeleccionados"
            :key="index"
            class="grid grid-cols-1 sm:grid-cols-6 gap-4 py-3 border-b border-gray-200"
          >
            <div class="">
              <h4 class="font-medium">{{ servicio.nombre }}</h4>
              <p class="text-sm text-gray-600">
                {{ servicio.descripcion || "Sin descripción" }}
              </p>
            </div>
            <div class="text-sm text-gray-600">
              {{ obtenerNombreTipo(servicio.tipoServicioId) }}
            </div>
            <div class="text-sm col-span-2 text-gray-600">
              <textarea
                type="text"
                class="block w-full p-2 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
                name=""
                id=""
                v-model="formData.observacion"
                rows="2"
              >
              </textarea>
            </div>
            <div class="font-medium">
              <input
                type="number"
                v-model="servicio.precioEditado"
                @change="
                  actualizarPrecioServicio(index, servicio.precioEditado)
                "
                class="block w-full p-1 text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-xs"
                min="0"
                step="0.01"
              />
            </div>
            <div class="text-end">
              <button
                type="button"
                @click="eliminarServicio(index)"
                class="text-red-500 hover:text-red-700"
              >
                <svg
                  class="w-4 h-4"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="mt-4 pt-4 border-t border-gray-200">
            <dl class="flex justify-between items-center">
              <dt class="text-lg font-semibold">Total:</dt>
              <dd class="text-2xl font-bold">
                ${{ formatMoney(totalCotizacion) }}
              </dd>
            </dl>
          </div>
        </div>

        <div class="mt-8 flex justify-end">
          <div class="inline-flex gap-x-2">
            <router-link
              to="/presupuesto"
              class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50"
            >
              Volver
            </router-link>
            <button
              type="submit"
              :disabled="serviciosSeleccionados.length === 0"
              class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-green-400 text-white hover:bg-green-700 disabled:opacity-50 disabled:pointer-events-none"
            >
              <svg
                class="w-6 h-6 text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m9 5 7 7-7 7"
                />
              </svg>
              Guardar presupuesto
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import servicioService from "../../composables/api/servicioService";
import presupuestoService from "../../composables/api/presupuestoService";

export default {
  name: "GenerarPresupuesto",
  data() {
    return {
      formData: {
        codigo: "",
        email: "",
        nombre: "",
        telefono: "",
        observacion: "",
        fecha: new Date().toLocaleDateString(),
        servicios: [],
        total: 0,
      },
      configCodigo: {
        // ...
      },
      todosServicios: [],
      serviciosFiltrados: [],
      tiposServicioUnicos: [], // Esta lista ahora se llena internamente
      serviciosSeleccionados: [],
      nuevoServicio: {
        tipoId: null,
        id: null,
      },
      totalCotizacion: 0,
      loading: false,
    };
  },
  async created() {
    await this.cargarTodosServicios();
  },
  methods: {
    formatMoney(value) {
      const amount = parseFloat(value || 0);
      return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },

    obtenerNombreTipo(tipoId) {
      const tipo = this.tiposServicioUnicos.find((t) => t.id === tipoId);
      return tipo ? tipo.nombre : "Sin tipo";
    },

    async cargarTodosServicios() {
      try {
        this.loading = true;
        const serviciosResponse = await servicioService.getAllServicios();

        if (serviciosResponse && Array.isArray(serviciosResponse)) {
          this.todosServicios = serviciosResponse.map((servicio) => ({
            ...servicio,
            precioEditado: servicio.precio,
          }));

          // Lógica para obtener tipos únicos y sus nombres
          const tiposUnicos = new Set();
          this.tiposServicioUnicos = this.todosServicios
            .filter((servicio) => {
              // Si el tipo de servicio ya fue procesado, no lo incluimos
              const esUnico = !tiposUnicos.has(servicio.tipoServicioId);
              if (esUnico) {
                tiposUnicos.add(servicio.tipoServicioId);
              }
              return esUnico;
            })
            .map((servicio) => ({
              id: servicio.tipoServicioId,
              nombre: servicio.nombre, // O el nombre del tipo, si lo tienes de otra fuente.
            }));

          console.log(
            "Tipos de servicio procesados:",
            this.tiposServicioUnicos
          );
        } else {
          console.error("Formato de respuesta inesperado:", serviciosResponse);
          this.todosServicios = [];
          this.tiposServicioUnicos = [];
        }
      } catch (error) {
        console.error("Error al cargar datos:", error);
        this.todosServicios = [];
        this.tiposServicioUnicos = [];
      } finally {
        this.loading = false;
      }
    },

    filtrarServiciosPorTipo() {
      this.nuevoServicio.id = null;
      if (this.nuevoServicio.tipoId === null) {
        this.serviciosFiltrados = [];
        return;
      }
      this.serviciosFiltrados = this.todosServicios.filter(
        (servicio) => servicio.tipoServicioId === this.nuevoServicio.tipoId
      );
    },

    agregarServicio() {
      if (!this.nuevoServicio.id) return;
      const servicio = this.todosServicios.find(
        (s) => s.id === this.nuevoServicio.id
      );
      if (!servicio) return;

      if (this.serviciosSeleccionados.some((s) => s.id === servicio.id)) {
        alert("Este servicio ya fue agregado al presupuesto");
        return;
      }

      const servicioParaAgregar = {
        ...servicio,
        precioEditado: servicio.precio,
      };

      this.serviciosSeleccionados.push(servicioParaAgregar);
      this.calcularTotal();

      this.nuevoServicio = {
        tipoId: null,
        id: null,
      };
      this.serviciosFiltrados = [];
    },

    actualizarPrecioServicio(index, nuevoPrecio) {
      const precio = parseFloat(nuevoPrecio);
      if (isNaN(precio) || precio < 0) {
        this.serviciosSeleccionados[index].precioEditado =
          this.serviciosSeleccionados[index].precio;
        return;
      }
      this.serviciosSeleccionados[index].precioEditado = precio;
      this.calcularTotal();
    },

    eliminarServicio(index) {
      this.serviciosSeleccionados.splice(index, 1);
      this.calcularTotal();
    },

    calcularTotal() {
      if (this.serviciosSeleccionados.length === 0) {
        this.totalCotizacion = 0;
        this.formData.total = 0;
        return;
      }

      this.totalCotizacion = this.serviciosSeleccionados.reduce(
        (total, servicio) => {
          const precio = parseFloat(servicio.precioEditado || servicio.precio);
          return total + precio;
        },
        0
      );

      this.formData.total = this.totalCotizacion;
      this.formData.servicios = this.serviciosSeleccionados.map((servicio) => ({
        id: servicio.id,
        precio: servicio.precioEditado,
      }));
    },

    async submitForm() {
      if (this.serviciosSeleccionados.length === 0) {
        alert("Por favor agregue al menos un servicio");
        return;
      }

      if (!this.formData.nombre?.trim()) {
        alert(
          "Por favor complete los campos obligatorios del cliente (Nombre)"
        );
        return;
      }

      try {
        this.loading = true;

        const detalles = this.serviciosSeleccionados.map((servicio) => ({
          servicioId: Number(servicio.id),
          precio: Number(servicio.precioEditado) || Number(servicio.precio),
        }));

        const presupuestoData = {
          fechaCreacion: new Date().toISOString(),
          codigo: this.formData.codigo?.trim() || `PRES-${Date.now()}`,
          email: this.formData.email.trim(),
          telefono: this.formData.telefono?.trim() || "",
          nombre: this.formData.nombre.trim(),
          observacion: this.formData.observacion?.trim() || "",
          detalles: detalles,
        };

        const resultado = await presupuestoService.createPresupuesto(
          presupuestoData
        );

        if (resultado?.id) {
          alert(`Presupuesto creado con ID: ${resultado.id}`);
          this.$router.push("/presupuesto");
        } else if (resultado?.success === false) {
          alert(`${resultado.error || "Error al crear el presupuesto"}`);
        } else {
          this.$router.push("/presupuesto");
        }
      } catch (error) {
        let errorMessage = "Error al crear presupuesto";
        if (error?.error) {
          errorMessage += `: ${error.error}`;
        } else if (error?.response?.data) {
          errorMessage += `: ${
            error.response.data.message || JSON.stringify(error.response.data)
          }`;
        } else {
          errorMessage += `: ${error.message || "Error desconocido"}`;
        }
        console.error("Error completo:", error);
        alert(errorMessage);
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.formData = {
        codigo: "",
        email: "",
        nombre: "",
        telefono: "",
        observacion: "",
        fecha: new Date().toLocaleDateString(),
        servicios: [],
        total: 0,
      };
      this.serviciosSeleccionados = [];
      this.nuevoServicio = {
        tipoId: null,
        id: null,
      };
      this.totalCotizacion = 0;
      this.serviciosFiltrados = [];
    },
  },
};
</script>
